module.exports = __webpack_public_path__ + "static/media/CloseCircle.dcb3e86c.svg";